import { render, staticRenderFns } from "./DetailShipper.vue?vue&type=template&id=7452c3ae"
import script from "./DetailShipper.vue?vue&type=script&lang=js"
export * from "./DetailShipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports